<template>
  <div class="flex-container">
    <!-- 顶部面包屑 -->
    <div class="flex-header">
      <div class="channel-header" v-if="channel.id">
        <h2 class="channel-title">
          {{ channel.channelName }}
          <el-tag
              :type="channel.saleModel === '0' ? 'success' : channel.saleModel === '1' ? 'info' : ''"
              size="small"
              style="margin-left:10px;vertical-align:middle;"
          >
            {{ channel.saleModel === '0' ? '线上' : channel.saleModel === '1' ? '线下' : '-' }}
          </el-tag>
          <el-tag
              v-if="channel.publicityDate"
              type="success"
              size="small"
              effect="plain"
              style="margin-left:8px;vertical-align:middle;"
          >
            已公示
          </el-tag>
          <el-tag
              v-if="channel.joinDate"
              type="warning"
              size="small"
              effect="plain"
              style="margin-left:8px;vertical-align:middle;"
          >
            已挂网
          </el-tag>
          <el-tag
              v-if="channel.exitDate"
              type="error"
              size="small"
              style="margin-left:8px;vertical-align:middle;background:#f56c6c;color:#fff;border-color:#f56c6c;font-weight:bold;"
          >
            已退出
          </el-tag>
        </h2>
        <div class="channel-meta">
          <span>统一信用代码：{{ channel.creditCode || '-' }}</span>
          <span>企业简称：{{ channel.channelShortName || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="flex-item main-content">
      <el-tabs v-model="activeTab" class="detail-tabs" @tab-click="onTabClick">
        <!-- Tab 1: 基本信息 -->
        <el-tab-pane label="基本信息" name="basic">
          <el-card class="section-card" shadow="never">
            <div slot="header" class="section-header">
              <span>渠道信息</span>
            </div>
            <!-- 水平滚动容器，防止窄屏表格挤压 -->
            <div class="descriptions-scroll">
              <el-descriptions
                  :column="2"
                  border
                  size="small"
                  v-loading="loading.info"
                  v-if="channel.id"
                  :label-style="labelStyle"
                  :content-style="contentStyle"
              >
                <el-descriptions-item label="渠道名称">{{ channel.channelName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="企业简称">{{ channel.channelShortName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="统一信用代码">{{ channel.creditCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="销售模式">
                  {{ channel.saleModel === '0' ? '线上' : channel.saleModel === '1' ? '线下' : '-' }}
                </el-descriptions-item>
                <el-descriptions-item label="注册所在地">{{ channel.regLocation || '-' }}</el-descriptions-item>
                <el-descriptions-item label="总部地址">{{ channel.officeAddress || '-' }}</el-descriptions-item>
                <el-descriptions-item label="企业官网域名">{{ channel.website || '-' }}</el-descriptions-item>
                <el-descriptions-item label="线上平台名称">{{ channel.platformName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="法定代表人">{{ channel.legalRep || '-' }}</el-descriptions-item>
                <el-descriptions-item label="业务联系人">{{ channel.contact || '-' }}</el-descriptions-item>
                <el-descriptions-item label="法人手机号">{{ channel.legalRepPhone || '-' }}</el-descriptions-item>
                <el-descriptions-item label="联系人手机号">{{ channel.contactPhone || '-' }}</el-descriptions-item>
                <el-descriptions-item label="经营范围" :span="2">{{ channel.businessScope || '-' }}</el-descriptions-item>
                <el-descriptions-item label="企业简述" :span="2">{{ channel.summary || '-' }}</el-descriptions-item>
              </el-descriptions>
              <el-empty v-else-if="!loading.info" description="暂无渠道信息" />
            </div>
          </el-card>
        </el-tab-pane>

        <!-- Tab 2: 资质文件（文档树） -->
        <el-tab-pane label="资质文件" name="qualification">
          <div class="tree-container" v-loading="loading.files">
            <el-tree
                v-if="qualificationFiles.length > 0"
                :data="qualificationFiles"
                :props="{ children: 'children', label: 'label' }"
                default-expand-all
                node-key="id"
                highlight-current
                style="width: 100%; padding: 8px 0;"
                v-loading="loading.files"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span class="tree-node-label" :title="data.label">
                  <i :class="data.type === 'folder' ? 'el-icon-folder' : getFileIcon(data.extension)" class="tree-node-icon"></i>
                  {{ data.label }}
                </span>
                <span class="tree-node-actions" v-if="data.type === 'file'">
                  <el-button type="text" size="mini" @click.stop="previewFile(data)" v-if="data.extension === 'pdf'">预览</el-button>
                  <el-button type="text" size="mini" @click.stop="downloadFile(data)">下载</el-button>
                </span>
              </span>
            </el-tree>
            <el-empty v-else description="暂无资质文件" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { currentChannel, getQualificationFiles } from "@/api/system/channel";
import { SYS_APi_SCREENING_URL } from '@/utils/globals';
import { streamDownload } from '@/utils/download';

export default {
  name: "channelBasicInfo",
  data() {
    return {
      channel: {},
      activeTab: 'basic',
      qualificationFiles: [],
      loading: { info: false, files: false },
      // 标签样式：固定宽度，禁止换行，保证不被压缩
      labelStyle: {
        width: '130px',
        minWidth: '130px',
        textAlign: 'right',
        whiteSpace: 'nowrap',
        fontWeight: '500',
        color: '#606266',
        backgroundColor: '#fafafa'
      },
      // 内容样式：允许长单词换行，行高舒适
      contentStyle: {
        minWidth: '180px',
        wordBreak: 'break-all',
        lineHeight: '1.6',
        color: '#303133'
      }
    };
  },
  created() {
    this.loadChannel();
  },
  methods: {
    loadChannel() {
      this.loading.info = true;
      currentChannel().then(res => {
        if (res && res.code === '200') {
          this.channel = res.data || {};
        } else {
          this.$message.error(res && res.message ? res.message : '加载渠道信息失败');
        }
      }).catch(() => {
        this.$message.error('加载渠道信息失败，请稍后重试');
      }).finally(() => {
        this.loading.info = false;
      });
    },
    onTabClick(tab) {
      if (tab.paneName === 'qualification' && this.qualificationFiles.length === 0) {
        this.loadQualificationFiles();
      }
    },
    loadQualificationFiles() {
      this.loading.files = true;
      const channelId = this.channel.id || '';
      if (!channelId) {
        this.qualificationFiles = [];
        this.loading.files = false;
        return;
      }
      getQualificationFiles({ channelId }).then(res => {
        if (res && res.code === '200') {
          this.qualificationFiles = res.data || [];
        } else {
          this.qualificationFiles = [];
        }
      }).catch(() => {
        this.qualificationFiles = [];
      }).finally(() => {
        this.loading.files = false;
      });
    },
    /**
     * 将平铺文件列表构建为树形结构
     * 假设每个文件对象包含 fileName 字段，可能包含路径分隔符 '/'
     * 例如：'资质文件/营业执照.pdf' => 创建 '资质文件' 文件夹节点
     */
    buildFileTree(fileList) {
      const root = [];
      const folderMap = {}; // 用于缓存文件夹节点

      fileList.forEach((file, index) => {
        const fileName = file.fileName || `未命名文件_${index}`;
        const parts = fileName.split('/');
        let currentLevel = root;
        let currentPath = '';

        parts.forEach((part, partIndex) => {
          currentPath = currentPath ? `${currentPath}/${part}` : part;
          const isFile = partIndex === parts.length - 1;

          if (isFile) {
            // 创建文件节点
            const extension = part.includes('.') ? part.split('.').pop().toLowerCase() : '';
            const fileNode = {
              id: `file_${file.fileId || index}_${partIndex}`,
              label: part,
              type: 'file',
              extension: extension,
              fileId: file.fileId,
              fileName: fileName,
              fileSize: file.fileSize,
              uploadTime: file.uploadTime,
              // 保留原始数据
              raw: file
            };
            currentLevel.push(fileNode);
          } else {
            // 创建或获取文件夹节点
            if (!folderMap[currentPath]) {
              const folderNode = {
                id: `folder_${currentPath}`,
                label: part,
                type: 'folder',
                children: []
              };
              folderMap[currentPath] = folderNode;
              currentLevel.push(folderNode);
            }
            currentLevel = folderMap[currentPath].children;
          }
        });
      });

      return root;
    },
    getFileIcon(extension) {
      const iconMap = {
        'pdf': 'el-icon-document',
        'jpg': 'el-icon-picture',
        'jpeg': 'el-icon-picture',
        'png': 'el-icon-picture',
        'gif': 'el-icon-picture',
        'bmp': 'el-icon-picture',
        'webp': 'el-icon-picture',
        'doc': 'el-icon-document',
        'docx': 'el-icon-document',
        'xls': 'el-icon-document',
        'xlsx': 'el-icon-document',
        'ppt': 'el-icon-document',
        'pptx': 'el-icon-document',
        'txt': 'el-icon-document',
        'zip': 'el-icon-folder-opened',
        'rar': 'el-icon-folder-opened',
        '7z': 'el-icon-folder-opened'
      };
      return iconMap[extension] || 'el-icon-document';
    },
    isImage(fileName) {
      if (!fileName) return false;
      const ext = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
    },
    previewFile(file) {
      if (!file.path) return;
      const loading = this.$loading({
        lock: true,
        text: '加载文件中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const token = this.$store.state.token;
      if (!token) {
        this.$message.error('未登录，无法预览');
        loading.close();
        return;
      }
      const apiUrl = SYS_APi_SCREENING_URL + '/filedown/bigFileDownLoad';
      const params = new URLSearchParams();
      params.append('url', file.path);
      params.append('name', file.label);
      const finalUrl = `${apiUrl}?${params.toString()}`;
      fetch(finalUrl, { headers: { 'token': token } })
          .then(res => {
            if (!res.ok) throw new Error(`服务器错误: ${res.status}`);
            return res.blob();
          })
          .then(blob => {
            loading.close();
            const blobUrl = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            window.open(blobUrl, '_blank');
          })
          .catch(() => {
            loading.close();
            this.$message.error('预览失败');
          });
    },
    downloadFile(row) {
      const loading = this.$loading({
        lock: true,
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const apiUrl = SYS_APi_SCREENING_URL + '/filedown/bigFileDownLoad';
      const params = new URLSearchParams();
      params.append('url', row.path || row.filePath || '');
      params.append('name', row.label || row.fileName || 'download');
      const finalUrl = `${apiUrl}?${params.toString()}`;
      const token = this.$store.state.token;
      if (!token) {
        this.$message.error('未登录，无法下载');
        loading.close();
        return;
      }
      streamDownload(finalUrl, {
          token,
          filename: row.label || row.fileName || 'download',
          onProgress: (percent, downloadedMB) => {
            if (!percent) {
              loading.setText('正在下载...');
            } else if (downloadedMB < 1) {
              loading.setText(`正在下载 ${percent}% (${(downloadedMB * 1024).toFixed(0)} KB)...`);
            } else {
              loading.setText(`正在下载 ${percent}% (${downloadedMB.toFixed(1)} MB)...`);
            }
          },
        })
        .then(() => { this.$message.success('下载成功'); })
        .catch(err => {
          if (err.name !== 'AbortError') {
            console.error(err);
            this.$message.error(err.message || '下载失败');
          }
        })
        .finally(() => { loading.close(); });
    },
    formatFileSize(bytes) {
      if (!bytes) return '-';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }
  }
};
</script>

<style scoped>
/* 整体布局：flex 纵向，占满高度 */
.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  background-color: #f0f2f5;
  padding: 8px;
  box-sizing: border-box;
}
.flex-header {
  flex-shrink: 0;
  background: #fff;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.06);
}
.flex-item:nth-child(2) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}
.main-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 渠道信息头部卡片 */
.channel-header {
  padding: 14px 0 4px;
  border-bottom: 1px solid #ebeef5;
}
.channel-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  display: flex;
  align-items: center;
}
.channel-code {
  font-size: 14px;
  font-weight: 400;
  color: #909399;
  margin-left: 8px;
}
.channel-meta {
  margin-top: 10px;
  font-size: 13px;
  color: #909399;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.channel-meta span {
  white-space: nowrap;
}

/* Tab 容器 */
.detail-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.06);
  padding: 0 16px;
}
.detail-tabs >>> .el-tabs__header {
  background: #fff;
  margin-bottom: 0;
  flex-shrink: 0;
  border-bottom: 1px solid #ebeef5;
}
.detail-tabs >>> .el-tabs__content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 0;
  padding-right: 6px;
}

/* 垂直滚动条 */
.detail-tabs >>> .el-tabs__content::-webkit-scrollbar,
.descriptions-scroll::-webkit-scrollbar,
.tree-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.detail-tabs >>> .el-tabs__content::-webkit-scrollbar-track,
.descriptions-scroll::-webkit-scrollbar-track,
.tree-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.detail-tabs >>> .el-tabs__content::-webkit-scrollbar-thumb,
.descriptions-scroll::-webkit-scrollbar-thumb,
.tree-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.detail-tabs >>> .el-tabs__content::-webkit-scrollbar-thumb:hover,
.descriptions-scroll::-webkit-scrollbar-thumb:hover,
.tree-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 卡片 */
.section-card {
  border-radius: 6px;
  border: none;
  box-shadow: none;
  background: transparent;
}
.section-card >>> .el-card__header {
  padding: 8px 0;
  background: transparent;
  border-bottom: 1px solid #ebeef5;
}
.section-header {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}
.section-header::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 16px;
  background: #409EFF;
  border-radius: 2px;
  margin-right: 8px;
}

/* 描述列表水平滚动容器 */
.descriptions-scroll {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 4px;
}

/* 文档树容器 */
.tree-container {
  width: 100%;
  height: 100%;
  overflow: auto; /* 允许内部滚动 */
  padding-bottom: 8px;
}

/* 自定义树节点样式 */
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  min-width: 0; /* 防止溢出 */
}
.tree-node-label {
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}
.tree-node-icon {
  margin-right: 6px;
  font-size: 16px;
  color: #606266;
}
.tree-node-actions {
  display: flex;
  align-items: center;
  margin-left: 12px;
  flex-shrink: 0;
}
.tree-node-actions .el-button {
  padding: 0;
  margin-left: 8px;
}

/* 响应式：小屏幕下调整 */
@media (max-width: 768px) {
  .flex-container {
    padding: 8px;
  }
  .channel-title {
    font-size: 16px;
    flex-wrap: wrap;
  }
  .channel-meta {
    gap: 12px;
  }
  .tree-node-actions .el-button {
    display: none; /* 移动端隐藏操作按钮，可点击节点展开后操作 */
  }
}
</style>